export default __webpack_public_path__ + "static/media/project-two-img.4392f59f.svg";